/**
 * SEIONA Theme JavaScript
 * Handles all interactive elements
 */

(function() {
  'use strict';

  // ============================================
  // Mobile Navigation
  // ============================================
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      mobileNav.classList.toggle('is-active');
      document.body.classList.toggle('nav-open');
    });
  }

  // ============================================
  // Sticky Header
  // ============================================
  const header = document.querySelector('.site-header');
  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeader() {
    const scrollY = window.scrollY;

    if (scrollY > 100) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    // Hide on scroll down, show on scroll up
    if (scrollY > lastScrollY && scrollY > 200) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  // ============================================
  // Quantity Selector
  // ============================================
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    const input = selector.querySelector('input[type="number"]');
    const minusBtn = selector.querySelector('.qty-btn.minus');
    const plusBtn = selector.querySelector('.qty-btn.plus');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', function() {
        const currentVal = parseInt(input.value) || 1;
        const minVal = parseInt(input.min) || 1;
        if (currentVal > minVal) {
          input.value = currentVal - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn.addEventListener('click', function() {
        const currentVal = parseInt(input.value) || 1;
        const maxVal = parseInt(input.max) || 999;
        if (currentVal < maxVal) {
          input.value = currentVal + 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }
  });

  // ============================================
  // FAQ Accordion
  // ============================================
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close all other FAQs
      document.querySelectorAll('.faq-item').forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.faq-answer').style.maxHeight = null;
        }
      });

      // Toggle current FAQ
      this.setAttribute('aria-expanded', !isExpanded);
      if (!isExpanded) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = null;
      }
    });
  });

  // ============================================
  // Product Accordion
  // ============================================
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
    });
  });

  // ============================================
  // Product Thumbnail Gallery
  // ============================================
  const thumbnails = document.querySelectorAll('.product-thumbnails .thumbnail');
  const mainImage = document.getElementById('ProductMainImage');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Remove active class from all
        thumbnails.forEach(t => t.classList.remove('active'));
        // Add active to clicked
        this.classList.add('active');

        // Update main image
        mainImage.src = this.dataset.imageSrc || this.querySelector('img').src;
        mainImage.alt = this.dataset.imageAlt || this.querySelector('img').alt;
      });
    });
  }

  // ============================================
  // Add to Cart (AJAX)
  // ============================================
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        updateCartCount();

        // Show success message
        showNotification('Added to cart!', 'success');

        // Reset button
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        showNotification('Error adding to cart. Please try again.', 'error');
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountEl = document.querySelector('[data-cart-count]');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }
      });
  }

  // ============================================
  // Notification System
  // ============================================
  function showNotification(message, type) {
    // Remove existing notifications
    const existing = document.querySelector('.notification');
    if (existing) existing.remove();

    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.innerHTML = `
      <span>${message}</span>
      <button type="button" class="notification-close">&times;</button>
    `;

    document.body.appendChild(notification);

    // Show with animation
    setTimeout(() => notification.classList.add('is-visible'), 10);

    // Auto-hide after 5 seconds
    const autoHide = setTimeout(() => hideNotification(notification), 5000);

    // Close button
    notification.querySelector('.notification-close').addEventListener('click', function() {
      clearTimeout(autoHide);
      hideNotification(notification);
    });
  }

  function hideNotification(notification) {
    notification.classList.remove('is-visible');
    setTimeout(() => notification.remove(), 300);
  }

  // Add notification styles if not already present
  if (!document.querySelector('#notification-styles')) {
    const style = document.createElement('style');
    style.id = 'notification-styles';
    style.textContent = `
      .notification {
        position: fixed;
        bottom: 20px;
        right: 20px;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 1rem;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        transform: translateY(100%);
        opacity: 0;
        transition: all 0.3s ease;
        z-index: 9999;
      }
      .notification.is-visible {
        transform: translateY(0);
        opacity: 1;
      }
      .notification-success {
        background: #34a853;
        color: white;
      }
      .notification-error {
        background: #ea4335;
        color: white;
      }
      .notification-close {
        background: none;
        border: none;
        color: inherit;
        font-size: 1.25rem;
        cursor: pointer;
        opacity: 0.8;
      }
      .notification-close:hover {
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }

  // ============================================
  // Newsletter Form
  // ============================================
  const newsletterForms = document.querySelectorAll('#newsletter-form, #newsletter-signup');

  newsletterForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      const emailInput = form.querySelector('input[type="email"]');

      if (emailInput && !isValidEmail(emailInput.value)) {
        e.preventDefault();
        showNotification('Please enter a valid email address.', 'error');
      }
    });
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ============================================
  // Lazy Loading Images
  // ============================================
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    const imageObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(function(img) {
      imageObserver.observe(img);
    });
  }

  // ============================================
  // Smooth Scroll for Anchor Links
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ============================================
  // Product Card Hover Effects
  // ============================================
  document.querySelectorAll('.product-card').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      this.querySelector('.product-card-actions')?.classList.add('is-visible');
    });

    card.addEventListener('mouseleave', function() {
      this.querySelector('.product-card-actions')?.classList.remove('is-visible');
    });
  });

  // ============================================
  // Print Styles
  // ============================================
  window.addEventListener('beforeprint', function() {
    // Expand all accordions for printing
    document.querySelectorAll('.faq-answer, .accordion-content').forEach(function(content) {
      content.style.maxHeight = 'none';
    });
  });

  window.addEventListener('afterprint', function() {
    // Reset accordions after printing
    document.querySelectorAll('.faq-question, .accordion-trigger').forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.faq-answer, .accordion-content').forEach(function(content) {
      content.style.maxHeight = null;
    });
  });

})();
